import { fg } from '@atlassian/jira-feature-gating';
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { safeCloneResource } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import type { PersistentIssueCreateModalViewResource } from './PersistentIssueCreateModalView.types.tsx';

export const persistentIssueCreateModalViewResource: RouteResource<PersistentIssueCreateModalViewResource> =
	safeCloneResource(
		createResource<PersistentIssueCreateModalViewResource>({
			type: 'RESOURCE_PERSISTENT_ISSUE_CREATE_MODAL_VIEW',
			getKey: () => 'state',
			getDataLoader: () =>
				import(
					/* webpackChunkName: "async-router-resources-persistent-issue-create-modal-view", jiraSpaEntry: "async-router-resources-persistent-issue-create-modal-view" */ './getData.tsx'
				),
			maxAge: Number.MAX_VALUE,
		}),
		{
			get isPageShellCritical() {
				return !fg('jira_ssr_demote_optional_critical_resources');
			},
		},
	);
